// Search-panel schema for the IM Item Management transactions grid (Delphi IMD0046 header fields).
// The 8 primary fields are spread across 4 groups (2 visible each) for a balanced layout; the remaining
// user-defined fields ride along hidden (visible: false) and are reachable via the form's field chooser.
const f = (name, label, type, visible, options) => ({
  name, tableName: "", label, type, options: options || null, apiUrl: null, grid: null, required: false, visible,
});

const codes = (from, to) => {
  const out = [];
  for (let i = from; i <= to; i++) out.push(f(`Code${i}`, `Code - ${i}`, "text", false));
  return out;
};
const references = (from, to) => {
  const out = [];
  for (let i = from; i <= to; i++) out.push(f(`Reference${i}`, `Reference - ${i}`, "text", false));
  return out;
};

const TransactionsFormLayout = [
  {
    groupId: 1,
    label: "",
    fields: [
      // Coded fields render as descriptive dropdowns (options injected in onFormLoad).
      f("TransactionType", "Trans Type", "select", true),
      f("Stage", "Stage", "select", true),
      ...codes(1, 3),
    ],
  },
  {
    groupId: 2,
    label: "",
    fields: [
      f("Status", "Status", "select", true),
      f("TransactionDateFrom", "Trans Date From", "date", true),
      ...codes(4, 6),
    ],
  },
  {
    groupId: 3,
    label: "",
    fields: [
      f("TransactionDateTo", "Trans Date To", "date", true),
      f("Reference", "Reference #", "text", true),
      ...codes(7, 10),
    ],
  },
  {
    groupId: 4,
    label: "",
    fields: [
      f("Description", "Description", "textarea", true),
      f("FiscalYear", "Fiscal Year", "number", true),
      f("FiscalPeriod", "Fiscal Period", "number", false),
      ...references(1, 10),
    ],
  },
];

export default TransactionsFormLayout;
